function IdGen() {
  return Math.floor(Math.random() * 1000);
}

export default IdGen;
